import {searchUsersNext, searchUsersPost} from "../services/search";
import headerTemplate from '../templates/header';
import {getFragment} from "./tools";
import {
    HEADER_CONTENT,
    LOAD_MORE_BUTTON,
    TOTAL_USERS,
    USER_LIST_SECTION
} from "../constants/elementConst";
import {PREFIX} from "../constants/styleConst";
import {usersTemplate} from "../templates/users";
import store from '../store';

export const renderUsers = async (target) => {
    if(store.get("noInitUsers")){
        store.set("noInitUsers", false);
        getFragment(target,HEADER_CONTENT).innerHTML = headerTemplate();
    }

    try{
        getFragment(target,USER_LIST_SECTION).innerHTML = "";
        getFragment(target,USER_LIST_SECTION).classList.add(`${PREFIX}__loader`);

        const searchResult = await searchUsersPost();

        const {TotalCount,SearchResultUsers} = searchResult;

        store.set("userList",SearchResultUsers);
        store.set("searchOptionNext",searchResult.NextSearchOptions);
        store.set("totalCount", TotalCount);
        store.set("currentCount",SearchResultUsers.length);

        getFragment(target,USER_LIST_SECTION).innerHTML = usersTemplate();
        getFragment(target, TOTAL_USERS).innerHTML = `${store.get("currentCount")} av ${store.get("totalCount")}`;
    }catch (error) {
        getFragment(target,TOTAL_USERS).innerHTML = 0;
        getFragment(target,USER_LIST_SECTION).innerHTML = error;
    }

    getFragment(target,USER_LIST_SECTION).classList.remove(`${PREFIX}__loader`);
};

export const appendUsers = async (target) => {
    try{
        const searchResult = await searchUsersNext();
        const loadMore = getFragment(target,LOAD_MORE_BUTTON);

        loadMore.parentNode.removeChild(loadMore);

        const {TotalCount,NextSearchOptions,SearchResultUsers} = searchResult;
        const currentUserList = store.get("userList");

        store.set("userList",SearchResultUsers);
        store.set("searchOptionNext",NextSearchOptions);
        store.set("totalCount",TotalCount);
        store.set("currentCount",store.get("currentCount") + SearchResultUsers.length);

        getFragment(target,USER_LIST_SECTION).insertAdjacentHTML("beforeend",usersTemplate());

        store.set("userList",[...currentUserList, ...SearchResultUsers]);

        getFragment(target,TOTAL_USERS).innerHTML = `${store.get("currentCount")} av ${TotalCount}`;
    }catch (error) {
        getFragment(target,TOTAL_USERS).innerHTML = 0;
        getFragment(target,USER_LIST_SECTION).innerHTML = error;
    }
};